<template>
    <modal
        :active="active"
        :large="true"
        :title="title"
        @closed="$emit('closed', true)"
    >
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th class="event">Hændelse</th>
                    <th class="created-by">Oprettet af</th>
                    <th class="created">Oprettet</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="event in listSerialEvents" :key="event.id">
                    <td>{{ event.event }}</td>
                    <td>{{ event.created_by }}</td>
                    <td>{{ event.created_at }}</td>
                </tr>
            </tbody>
        </table>

        <template v-slot:footer class="has-space-between">
            <button class="button is-default" @click="$emit('closed', true)">Luk historik</button>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {mapGetters} from "vuex";

export default {
    components: {
        Modal,
    },
    props: {
        active: Boolean,
        serial: Object,
    },
    computed: {
        ...mapGetters([
            'listSerialEvents',
        ]),
        title() {
            return this.serial && this.serial.serial ? 'Serienummer historik for: ' + this.serial.serial : 'Serienummer historik';
        },
    },
}
</script>

<style scoped>
    .event {
        width: 60%;
    }
    .created-by {
        width: 20%;
    }
    .created {
        width: 20%;
    }
</style>
